module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n    #stagesAndRoles{\r\n        border: 1px #eee solid;\r\n        width: 100%;\r\n    }\r\n    #stagesAndRoles td {\r\n        width: 134px;\r\n    }\r\n</style>\r\n\r\n<div id=\"dialog\" title=\"")
    ; __append(escapeFn(title))
    ; __append("\" >\r\n    <table id=\"stagesAndRoles\" style=\"table-layout:fixed;\">\r\n        <thead>\r\n            <tr>\r\n                <th>\r\n                    Stages\r\n                </th>\r\n                <th>\r\n                    Roles\r\n                </th>\r\n                ")
    ; 
                roles.forEach(function(role){
                    
    ; __append("\r\n                    <th class=\"table-ellipsis\" style=\"padding-bottom: 20px; vertical-align:bottom;\">\r\n                        ")
    ; __append(escapeFn(role.name))
    ; __append(" <br />\r\n                        <select class=\"switch-role\" data-role-id=\"")
    ; __append(escapeFn(role.id))
    ; __append("\">\r\n                            <option value=\"\"></option>\r\n                            ")
    ; 
                            options.forEach(function(option){
                            
    ; __append("\r\n                                    <option value=\"")
    ; __append(escapeFn(option.value))
    ; __append("\">")
    ; __append(escapeFn(option.label))
    ; __append("</option>\r\n                            ")
    ; 
                            })
                            
    ; __append("\r\n                        </select>\r\n                    </th>\r\n                    ")
    ; 
                })
                
    ; __append("\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n        ")
    ; 
        matrix.forEach(function(stage){
            
    ; __append("\r\n            <tr>\r\n                <td class=\"table-ellipsis\">\r\n                    ")
    ; __append(escapeFn(stage.name))
    ; __append("\r\n                </td>\r\n                <td style=\"padding-right: 20px;\">\r\n                    <select class=\"switch-stage\" data-stage-id=\"")
    ; __append(escapeFn(stage.id))
    ; __append("\">\r\n                        <option value=\"\"></option>\r\n                        ")
    ; 
                        options.forEach(function(option){
                        
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(option.value))
    ; __append("\">")
    ; __append(escapeFn(option.label))
    ; __append("</option>\r\n                        ")
    ; 
                        })
                        
    ; __append("\r\n                    </select>\r\n                </td>\r\n                ")
    ; 
                stage.settings.forEach(function(setting){
                
    ; __append("\r\n                <td>\r\n                    <select class=\"setting-value\" data-role-id=\"")
    ; __append(escapeFn(setting.roleId))
    ; __append("\" data-stage-id=\"")
    ; __append(escapeFn(setting.stageId))
    ; __append("\">\r\n                        ")
    ; 
                        options.forEach(function(option){
                        
    ; __append("\r\n                            <option value=\"")
    ; __append(escapeFn(option.value))
    ; __append("\" ")
    ; __append(escapeFn((setting.value === option.value) ? 'selected="selected"' : ''))
    ; __append(" >")
    ; __append(escapeFn(option.label))
    ; __append("</option>\r\n                        ")
    ; 
                        })
                        
    ; __append("\r\n                    </select>\r\n                </td>\r\n                ")
    ; 
                })
                
    ; __append("\r\n            </tr>\r\n            ")
    ; 
        });
        
    ; __append("\r\n        </tbody>\r\n    </table>\r\n</div>")
  }
  return __output;

}